export class TranslationStateDisplayConfig {
  public color: string;
  public displayOrder: number;
  public displayName: string;

  constructor(color: string, displayOrder: number, displayName: string) {
    this.color = color;
    this.displayOrder = displayOrder;
    this.displayName = displayName;
  }
}
